import { ContentCard } from "@/components/ContentCard";
import { type ContentKind, getContentByKind } from "@/data/site";
import { useSiteContent } from "@/data/SiteContentContext";

const copy: Record<ContentKind, { title: string; intro: string; eyebrow: string }> = {
  journal: {
    eyebrow: "// journal",
    title: "Journal",
    intro: "Personal notes from Brian.",
  },
  guide: {
    eyebrow: "// guides",
    title: "Guides",
    intro: "Step-by-step walkthroughs for the systems I actually run.",
  },
  script: {
    eyebrow: "// scripts",
    title: "Scripts",
    intro: "PowerShell snippets and scripts ready to copy or deploy.",
  },
};

export function ContentIndexPage({ kind }: { kind: ContentKind }) {
  const { content } = useSiteContent();
  const items = getContentByKind(content, kind);
  const page = copy[kind];

  return (
    <div className="space-y-10">
      <header className="max-w-2xl space-y-3">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--color-primary)]">{page.eyebrow}</p>
        <h1 className="text-4xl font-semibold tracking-tight">{page.title}</h1>
        <p className="text-lg text-[var(--color-muted)]">{page.intro}</p>
      </header>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {items.map((item) => (
          <ContentCard key={item.slug} item={item} />
        ))}
      </div>
    </div>
  );
}
